module.exports = __webpack_public_path__ + "static/contact-a7e54eb328443c60db9730625f86d11b.jpg";